import {LocalStorage} from "../../utils/storage";
import { getComponentLabels } from '../../utils/languages';

export const PLAN_NAMES = {
  PRO: 'Pro',
  PYME: 'PyME',
  FULL: 'Full',
};

// Plan-gated capabilities that are not exposed as `plan_features` flags but are
// granted through the subscription plan's permissions (see backend
// SubscriptionPlan). Keyed by the formatted plan name stored in LocalStorage as
// `subscription_plan_name`. Plans not listed here are treated as including every
// capability (fail open), which covers organizations without an assigned plan.
export const PLAN_CAPABILITY = {
  KPI: 'kpi',
  NONCONFORMITY: 'nonconformity',
};

const PLAN_CAPABILITIES = {
  'Full Trazal': [PLAN_CAPABILITY.KPI, PLAN_CAPABILITY.NONCONFORMITY],
  'Pro': [PLAN_CAPABILITY.KPI, PLAN_CAPABILITY.NONCONFORMITY],
  'Premium': [PLAN_CAPABILITY.NONCONFORMITY],
  'PyME': [PLAN_CAPABILITY.NONCONFORMITY],
  'Avanzado': [PLAN_CAPABILITY.NONCONFORMITY],
  'Estándar': [PLAN_CAPABILITY.NONCONFORMITY],
  'Emprendedor': [],
};

export const planIncludes = (capability) => {
  const planName = LocalStorage.get('subscription_plan_name');
  const capabilities = PLAN_CAPABILITIES[planName];
  if (!capabilities) return true;
  return capabilities.includes(capability);
};

export const getPlanFeatureTooltip = (planName) => {
  const labels = getComponentLabels('featureFlags');
  return labels.plan_feature_tooltip.replace('{plan}', planName);
};

export const getPlanAvailableFromTooltip = (planName) => {
  const labels = getComponentLabels('featureFlags');
  return labels.plan_available_from_tooltip.replace('{plan}', planName);
};

export const planFeatures = {

    uploadFiles: function() {
      return LocalStorage.existsIn('plan_features', 'upload_files');
    },

    customLogo:function() {
      return LocalStorage.existsIn('plan_features', 'custom_logo');
    } ,
    customPrints: function () {
       return LocalStorage.existsIn('plan_features', 'custom_prints');
    },
    costs: function () {
       return LocalStorage.existsIn('plan_features', 'costs');
    },
    batchRequests: function () {
      return LocalStorage.existsIn('plan_features', 'batch_requests');
    },
    stockKpi: function () {
      return LocalStorage.existsIn('plan_features', 'stock_kpi');
    },
    statsKpis: function () {
      return LocalStorage.existsIn('plan_features', 'stats_kpis');
    },

}